import { useState, useCallback } from 'react'
import { Segmented, Tabs, TabsProps, Typography } from 'antd'
import { TeamSection, UserSection } from 'src/pages/budget/budgetTeams/widgets'

export const BudgetTeams = () => {
  const TABS = {
    TEAMS: 'Команды',
    USERS: 'Сотрудники',
  } as const

  type TabKey = typeof TABS[keyof typeof TABS]
  const [activeTab, setActiveTab] = useState<TabKey>(TABS.TEAMS)
  const { Title } = Typography

  const handleChange = useCallback(
    (key: string) => setActiveTab(key as TabKey),
    [],
  )

  const tabItems: TabsProps['items'] = [
    {
      key: TABS.TEAMS,
      label: null,
      children: <TeamSection />,
    },
    {
      key: TABS.USERS,
      label: null,
      children: <UserSection />,
    },
  ]

  return (
    <>
      <Title>Роли и доступы</Title>
      <Segmented
        value={activeTab}
        onChange={(value) => setActiveTab(value as TabKey)}
        options={[TABS.TEAMS, TABS.USERS]}
        style={{ fontSize: 18, marginBottom: 20 }}
        shape="round"
        size="large"
      />
      <Tabs
        activeKey={activeTab}
        items={tabItems}
        onChange={handleChange}
        tabBarStyle={{ display: 'none' }}
      />
    </>
  )
}
